import React, { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router";
import useAdminData from "../../hooks/useAdminData";
import { Container, Row } from 'react-bootstrap';

//  Components
import EditTestimonialForm from "../../components/Forms/EditTestimonialForm";
import Spinner from '../../components/Spinner';

const initialTestimonial = {
    name: "",
    title: "",
    text: "",
    profilePic: "",
};

const EditTestimonial = () => {
    const params = useParams();
    const location = useLocation();
    const { index } = location;
    const { getTestimonial, isLoading, error } = useAdminData();
    const [testimonial, setTestimonial] = useState(initialTestimonial);

    const fetchTestimonial = async id => {
        const response = await getTestimonial(id);
        return response.data.document;
    };

    useEffect(() => {
        fetchTestimonial(params.id).then(res => {
            setTestimonial(res);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    if (isLoading) {
        return <Spinner color={"red"} />;
    }
    
    if (error) {
        return <p>{error}</p>;
    }
    return <Container>
        <Row>
            <h1>Editar testemunho</h1>
            <EditTestimonialForm testimonial={testimonial} index={index}/>
        </Row>
    </Container>;
};

export default EditTestimonial;
